/**
 * Map utility functions for consistent map behavior
 */

/**
 * Calculate appropriate zoom level based on location type
 * Used for both mobile and desktop search functionality
 */
export function getZoomLevelForLocationType(locationType: string): number {
  switch (locationType) {
    case 'country':
      return 5; 
    case 'state':
    case 'province':
    case 'region':
      return 7;
    case 'county':
      return 8;
    case 'city':
    case 'town':
      return 11;
    case 'village':
    case 'hamlet':
    case 'suburb':
      return 13;
    case 'attraction':
    case 'natural':
    case 'building':
      return 15;
    default:
      return 9;
  }
} 